import $document from './document';
import $window from './window';

export const preferredStorelocalStorageKey = 'preferredStore';
export const pudosCheckoutDataStorageKey = 'pudosCheckoutData';

export function getBrandContext(brand = 'anf') {
  return ({
    anf: 'anf',
    kids: 'anf',
    hol: 'hol',
    gh: 'hol',
    st: 'hol',
  })[brand] || 'anf';
}

export const sha256 = (text) => new Promise((resolve, reject) => {
  // Check if the crypto API is available
  if (typeof crypto !== 'undefined' && crypto.subtle) {
    const msgBuffer = new TextEncoder().encode(text);

    crypto?.subtle?.digest('SHA-256', msgBuffer)
      .then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
        resolve(hashHex);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    reject(new Error('Crypto API is not available.'));
  }
});

export const setHashedEmailForAnalytics = async (email) => {
  if (!$window.digitalData || !email || email.trim() === '') return;
  $window.digitalData.set('user.hashedEmail', await sha256(email));
};

export function parseJSON(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return undefined;
  }
}

export function parseJSONObject(value) {
  const object = parseJSON(value);
  if (typeof object === 'object' && object !== null) {
    return object;
  }
  return {};
}

export const getParamFromUrl = (param, fallback = '') => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) || fallback;
};

export const buildLangCurrChangeURI = ({
  storeId,
  catalogId,
  langId,
  country,
  currency = 'USD',
  redirect = 'AjaxSuccessView',
}) => {
  const searchParams = new URLSearchParams({
    storeId,
    catalogId,
    langId,
    currency,
    country,
    URL: redirect,
  });
  return `/shop/LangCurrChange?${searchParams.toString()}`;
};
/**
 * Scrolls the page to the element with the given id, accounting for header offsets.
 *
 * @param {Object} params - The parameters object.
 * @param {string} params.id - The id of the element to scroll to.
 * @param {number} params.offset - Additional offset in pixels.
 * @param {boolean} params.isMobileView - Whether the view is mobile (affects header offset).
 */
export function scrollToElementById({ id, offset, isMobileView }) {
  const element = $document.getElementById(id);
  const desktopHeaderOffset = 75;
  const mobileHeaderOffset = 110; // header is 50px and sticky bag summary is 60px
  const totalOffset = offset + (isMobileView ? mobileHeaderOffset : desktopHeaderOffset);
  const elementPosition = element.getBoundingClientRect().top + $window.scrollY;
  const offsetPosition = elementPosition - totalOffset;
  $window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}
